import React, { useEffect, useState } from "react";
import { Container, makeStyles, Box } from "@material-ui/core";
import Page from "src/components/Page";
import Toolbar from "./Toolbar";
import OrderList from "./overDueOrderList";
import { useSelector, useDispatch } from "react-redux";
import { fetchAllDetails } from "./_overDue_Action";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const OverDueOrders = () => {
  const classes = useStyles();

  const [filterFn, setParentFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const dispatch = useDispatch();
  let allFetchData = useSelector((state) => state.overDueOrder._allDetails.listData) || [];

  useEffect(() => {
    dispatch(fetchAllDetails());
  }, []);

  let viewComponent;
  viewComponent = <OrderList TableData={allFetchData} filterFn={filterFn} />;

  return (
    <Page className={classes.root} title="Customer">
      <Container maxWidth={false}>
        <Toolbar setParentFilterFn={setParentFilterFn}/>
        <Box mt={3}>{viewComponent}</Box>
      </Container>
    </Page>
  );
};
export default OverDueOrders;
